import { BrowserRouter, Route, Routes } from 'react-router';

import type { LegalLocale } from './legal/documents';
import { privacyPolicy, termsOfUse } from './legal/documents';
import { PublicLocaleProvider } from './locale';
import { AccountDeletionPage, type AccountDeletionPageProps } from './screens/AccountDeletionPage';
import { CarListingPage } from './screens/CarListingPage';
import { HomePage } from './screens/HomePage';
import { LegalDocumentPage } from './screens/LegalDocumentPage';
import { NotFoundPage } from './screens/NotFoundPage';
import { SupportPage } from './screens/SupportPage';
import { PublicShell } from './shell/PublicShell';

export interface AppProps {
  initialLocale?: LegalLocale;
  deletion?: AccountDeletionPageProps;
}

export function App({ initialLocale, deletion }: AppProps) {
  return (
    <PublicLocaleProvider initialLocale={initialLocale}>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicShell />}>
            <Route index element={<HomePage />} />
            <Route path="privacy" element={<LegalDocumentPage document={privacyPolicy} />} />
            <Route path="terms" element={<LegalDocumentPage document={termsOfUse} />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="cars/:id" element={<CarListingPage />} />
            <Route path="account-deletion" element={<AccountDeletionPage {...deletion} />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </PublicLocaleProvider>
  );
}
